// extracted by mini-css-extract-plugin
export default {"busy-timeslots-form":"AddBusySlots_busy-timeslots-form__zV2bq","c-field-label":"AddBusySlots_c-field-label__bHpk4","disabled-field":"AddBusySlots_disabled-field__ZZJq4"};